import * as React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { RootState } from '../store'
import { AuthStatus } from '../store/auth/reducer'

export interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentClass
  status: AuthStatus
}

const ProtectedRoute = ({ component: Component, ...props }: ProtectedRouteProps) => (
  <Route {...props} render={(routeProps: any) => {

    if (props.status === 'authed') {
      return (<Component {...routeProps} />)
    }

    if (props.status === 'authenticating') {
      return (<p>Loading...</p>)
    }

    return (
      <Redirect to={{
        pathname: '/account/sign-in',
        state: { from: routeProps.location },
      }} />
    )

  }} />
)

const mapStateToProps = ({ auth }: RootState) => ({
  status: auth.status,
})

export default connect(mapStateToProps)(ProtectedRoute)



// WEBPACK FOOTER //
// ./src/common/ProtectedRoute.component.tsx